/**
 * PresentDashboardContainer
 * --
 */
import React from 'react';
import PresentDashboardPresenter from './PresentDashboardPresenter';
import dayjs from 'dayjs';
import { useGetPresents } from 'hooks/PresentHooks';

const DATE_FORMAT = 'YYYY.MM.DD';

const PresentDashboardContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== Date ===== */
  // 데이터 조회기간
  const { startDate, endDate } = React.useMemo(() => {
    return {
      startDate: dayjs().startOf('month').unix(),
      endDate: dayjs().unix(),
    };
  }, []);

  // 선물 데이터 호출
  const { data: Presents } = useGetPresents(
    {
      start_date: startDate,
      end_date: endDate,
    },
    {
      initialData: [],
      enabled: startDate && endDate ? true : false,
      select: (res) => {
        const { status, data, message } = res;

        if (status !== 200) {
          console.warn(message);
          return [];
        }

        return data;
      },
    }
  );

  /* ===== STATE ===== */
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 선물 데이터 정제
   * --
   */
  const PresentData = React.useMemo(() => {
    setIsLoading(true);

    if (!Presents.length) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      return [];
    }

    const newData = Presents;

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return newData;
  }, [Presents]);

  /* ===== VARIABLE ===== */
  const PROPS = {
    data: PresentData,
    isLoading,
    startDate,
    endDate,
    format: DATE_FORMAT,
  };

  /* ===== RENDER ===== */
  return (
    <>
      <PresentDashboardPresenter {...PROPS} />
    </>
  );
};

export default PresentDashboardContainer;
